import { useId, type SVGProps } from 'react'

export const GiftIcon = (props: SVGProps<SVGSVGElement>) => {
  const id = useId()
  const clipPathId = `${id}-clip`

  return (
    <svg
      aria-hidden="true"
      fill="none"
      focusable="false"
      viewBox="0 0 22 22"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M0 6.875C0 6.11445 0.614453 5.5 1.375 5.5H3.1625C3.47617 6.11016 3.94883 6.62578 4.52891 6.99102C4.82109 7.17148 5.13477 7.31328 5.46992 7.41211C5.6375 7.45938 5.80938 7.49805 5.98555 7.52383C6.07578 7.53672 6.16172 7.54531 6.25195 7.55391C6.29492 7.5582 6.34219 7.5582 6.38945 7.5625C6.43672 7.5668 6.47969 7.5668 6.52695 7.5668H9.27695H9.6207V11.0043L1.375 11C0.614453 11 0 10.3855 0 9.625V6.875ZM1.375 12.375H9.625V22H3.4375C2.29883 22 1.375 21.0762 1.375 19.9375V12.375ZM12.375 7.5625H15.4688C16.9383 7.5625 18.2102 6.72461 18.8375 5.5H20.625C21.3855 5.5 22 6.11445 22 6.875V9.625C22 10.3855 21.3855 11 20.625 11H12.375V7.5625ZM12.375 12.375H20.625V19.9375C20.625 21.0762 19.7012 22 18.5625 22H12.375V12.375Z"
          fill="currentColor"
          opacity="0.4"
        />
        <path
          d="M8.18555 2.95625L9.68086 5.5H9.625H9.28125H6.53125C5.58164 5.5 4.8125 4.73086 4.8125 3.78125C4.8125 2.83164 5.58164 2.0625 6.53125 2.0625H6.62578C7.26602 2.0625 7.86328 2.40195 8.18555 2.95625ZM11 3.67383L9.96445 1.91211C9.26836 0.726172 7.99648 0 6.62578 0H6.53125C4.44297 0 2.75 1.69297 2.75 3.78125C2.75 5.86953 4.44297 7.5625 6.53125 7.5625H9.28125H9.625V11H12.375V7.5625H15.4688C17.557 7.5625 19.25 5.86953 19.25 3.78125C19.25 1.69297 17.557 0 15.4688 0H15.3742C14.0035 0 12.7316 0.726172 12.0355 1.90781L11 3.67383ZM13.8145 2.95625C14.141 2.40195 14.734 2.0625 15.3742 2.0625H15.4688C16.4184 2.0625 17.1875 2.83164 17.1875 3.78125C17.1875 4.73086 16.4184 5.5 15.4688 5.5H12.3191L13.8145 2.95625ZM12.375 22V12.375H9.625V22H12.375Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect height="100%" width="100%" />
        </clipPath>
      </defs>
    </svg>
  )
}
